<script setup lang="ts">
import type { PortalContactSessionFragmentFragment } from '@/graphql/pp/generated/graphql';

defineProps<{
  user: PortalContactSessionFragmentFragment
  loading?: boolean,
  onLogout:() => void,
  onSuccess:(data: PortalContactSessionFragmentFragment) => void,
}>();
</script>
<template>
  <TermConditionsModal
    v-if="!user.terms_and_conditions_acknowledgment_dt && !user.sessionImpersonation"
    :open="true"
    :on-logout="onLogout"
    :loading="loading"
    :on-success="onSuccess"
  />
  <slot v-else />
</template>
